import React from "react";

import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { Button } from  "@material-ui/core";
import { Grid } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import ShipmentSavedSummary from '../../shipment-saved/sections/ShipmentSavedSummary.js'

import { TableRowStyled, TableCellStyled } from '../../common/TableStyled.js'
import { localizer } from '../../../Translator.js'

import { SnackbarCustom } from "../../Utilities/SnackbarCustom.js"
import DateCustom from "../../Utilities/DateCustom.js";
import { MultiShipmentImageViewer } from "../../Utilities/MultiShipmentImageViewer.js"

/**
 * Class component that represents a shipment 
 * as a row into the drafts list table.
 */
export class ShipmentSavedRow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
      openShipmentModal: false,
      openDraftModal: false,
      pageBase64Error: null,
      uploadDraftError: null,
                
      // Shipment object which feedback belong to
      shipment: {},
      shipmentFeedbacks: [],

      states: [],
      certs: [],
      proofs: [],
      reports: [],

      // Indicates if shipment summary of the feedback is open or closed
      openModal: false,
      feedbackShipmentError: null,
      feedbackShipmentStatestError: null,
      message: null,
      severity: "error",

      //viewer
      documentpages: [],
      pagenumber: 1,

      //Modal deleteDraft
      removeDraft: false,

      checked: true,
      shipmentsCodesSelected: [],

      // These flag indicates if page options menu must be opened or closed
      optionsMenu: null,
      openMenu: false,

    }
  }

  componentDidMount() {
    this.setState({ shipment: this.props.shipment, checked: this.props.checked, shipmentsCodesSelected: this.props.shipmentsCodesSelected })
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return
    let checked = this.props.shipmentsCodesSelected.includes(this.props.shipment.shipmentCode)
    this.setState({ checked: checked })
  }

  handleOpenShipmentModal = () => {
    this.setState({ openShipmentModal: true })
  }

  handleCloseShipmentModal = () => {
    this.setState({ openShipmentModal: false })
  }

  handleOpenDraftModal = () => {
    this.setState({ documentpages: this.state.shipment.pages, openDraftModal: true })
  }

  handleCloseDraftModal = () => {
    this.setState({ openDraftModal: false })
  }

  /**
   * Removes a shipment when the user press its 'accept ' button in dialog with options 
   */
  deleteShipment = () => {
    this.props.removeOrCancelShipment(this.state.shipment)
    this.setState({ openShipmentModal: false })
  }
  
  /**
   * Set the state open / collapsed of Collapse elements for expandable rows.
   */
  setOpen = () => {
    this.setState({ open: !this.state.open })
  }

  /**
   * Set the state open of shipment summary dialog.
  */
  handleOpenModal = () => {
    this.setState({ openModal: true })
  }

  /**
   * Set the state closed of shipment summary dialog.
  */
  handleCloseModal = () => {
    this.setState({ openModal: false })
  }

  setBorderStyleByState = () => {
    let border = "solid 5px #219A4A"

    if (!this.state.shipment) return border
    
    if (this.state.shipment.cancelTime) {
      border = "solid 5px #F90606"
      return border
    }

    if (!this.state.shipment.emissionTime) {
      border = "solid 5px #ff8c00"
      return border
    }

    if (new Date(this.state.shipment.emissionTime) > Date.now()) {
      border = "solid 5px #ABABAB"
      return border
    }

    return border
  }
  
  handleonClose = () => {
    this.setState({ uploadDraftError: null, pageBase64Error: null })
  }

  /**
   * Checkbox row onChange event. It calls the parent component function to add or remove feedback
   * from feedbacks selected list
   * @param {*} event 
   */
  handleChangeCheck = () => {
    const { addOrRemoveSelectedShipment } = this.props
    this.setState({ checked: !this.state.checked },
      () => {
       
        var shipmentCode = this.state.shipment.shipmentCode
        var option = this.state.checked ? "CHECKED" : "UNCHECKED"

        addOrRemoveSelectedShipment(shipmentCode, option)
      })
  }
  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  mountDestinationAddressWho = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let who = this.state.shipment.destinationAddress.who
    return who
  }

  getProductDescription = () => {
    let description = ""
    this.props.products && this.state.shipment.features && this.props.products.forEach(product => {
      if (product.productCode === this.state.shipment.features.productCode) {
        description = product.description
        return
      }
    })
    return description
  }

  /* Action menu handler */
  handleClickOptionsMenu = (event) => { this.setState({ optionsMenu: event.currentTarget, openMenu: true }) }
  handleOpenOptionsMenu = () => { this.setState({ openMenu: true }) }
  handleCloseOptionsMenu = () => { this.setState({ openMenu: false }) }

  render() {

    return (
      <React.Fragment>
        <TableRowStyled>
          <TableCellStyled className="text-align-center">
            <Checkbox
              //defaultChecked
              checked={this.state.checked !== undefined ? this.state.checked : false}
              onChange={this.handleChangeCheck}
              name={this.props.shipment.shipmentId}
              color="primary"
              icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
              checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
            />
          </TableCellStyled>
          <TableCellStyled className="text-align-center" style={{ borderLeft: this.setBorderStyleByState() }}>
            <Tooltip className="typography-generic" title={<Typography className="typography-generic">{this.state.open ? localizer.ExpandLess : localizer.ExpandMore}</Typography>}>
              <IconButton aria-label="expand row" size="small" onClick={this.setOpen}>
                {this.state.open ? <i className="fa-solid fa-angle-up font-size-20"></i> : <i className="fa-solid fa-angle-down font-size-20"></i>}
              </IconButton>
            </Tooltip>
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content font-weight-bold" onClick={this.setOpen} align="center">{this.state.shipment ? this.state.shipment.shipmentCode : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen}>{this.getProductDescription()}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" onClick={this.setOpen} align="center">{(this.state.shipment && this.state.shipment.ownerUser && this.props.currentUser.toLowerCase() !== this.state.shipment.ownerUser.toLowerCase()) ? this.state.shipment.ownerUser.toLowerCase() : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content font-weight-bold" align="center" onClick={this.setOpen}>
            {this.state.shipment && this.state.shipment.features && this.state.shipment.features.reference &&
              <Tooltip className="typography-generic" title={<Typography className="typography-generic">{this.state.shipment.features.reference}</Typography>}>
                <span>{this.state.shipment.features.reference.length > 20 ? this.state.shipment.features.reference.substring(0, 20) + "..." : this.state.shipment.features.reference}</span>
              </Tooltip>
            }
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen}>{this.state.shipment ? this.state.shipment.cancelTime !== null ? localizer.InboxNotSent : this.state.shipment.emissionTime !== null ? DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime) : localizer.InboxNotSent : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen} style={{ wordBreak: "break-all" }}>{this.mountDestinationAddressWho()}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen}>{this.state.shipment ? this.state.shipment.cancelTime !== null ? localizer.Cancelled : this.state.shipment.emissionTime === null ? localizer.InboxSaved : new Date(this.state.shipment.emissionTime) > Date.now() ? localizer.InboxProgrammed : localizer.InboxSent : ""}</TableCellStyled>
         
         {/*  <TableCellStyled align="center">
            <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.ViewDocument}</Typography>}>
              <IconButton className="button-generic icon-button" aria-label="Visibility" onClick={this.handleOpenDraftModal}>
                <i className="fa-solid fa-eye"></i>
              </IconButton>
            </Tooltip>
          </TableCellStyled> */}

          {/* <TableCellStyled align="center">
            {((this.state.shipment.dequeuedTime !== null) || this.props.currentUser.toLowerCase() !== this.state.shipment.ownerUser.toLowerCase()) ?
              <Tooltip title={<Typography className="typography-generic">{localizer.EditShipment}</Typography>}>
                <div>
                  <IconButton className="button-generic icon-button" aria-label="edit" disabled={true}><i className="fa-solid fa-pencil"></i></IconButton>
                </div>
              </Tooltip> :
              <Tooltip title={<Typography className="typography-generic">{localizer.EditShipment}</Typography>}>
                <Link to={"/shipment?shipmentCode=" + this.state.shipment.shipmentCode}>
                  <IconButton className="button-generic icon-button" aria-label="edit"><i className="fa-solid fa-pencil"></i></IconButton>
                </Link>
              </Tooltip>}
          </TableCellStyled> */}

         {/*  <TableCellStyled align="center">
            {((this.state.shipment.dequeuedTime !== null) || this.props.currentUser.toLowerCase() !== this.state.shipment.ownerUser.toLowerCase()) ?
              <Tooltip title={<Typography className="typography-generic">{localizer.DeleteShipment}</Typography>}>
                <div>
                  <IconButton className="button-generic icon-button" disabled={true} >
                    <i className="fa-solid fa-circle-xmark"></i>
                  </IconButton>
                </div>
              </Tooltip> :

              <Tooltip title={<Typography className="typography-generic">{localizer.DeleteShipment}</Typography>}>
                <IconButton className="button-generic icon-button" onClick={this.handleOpenShipmentModal}>
                  <i className="fa-solid fa-circle-xmark"></i>
                </IconButton>
              </Tooltip>
            }
          </TableCellStyled> */}

          {/* Action Menu */}
          <TableCellStyled align="center">
            <IconButton style={{ width: "20px", height: "20px" }} aria-label="more" aria-controls="shipment-options" aria-haspopup="true" onClick={this.handleClickOptionsMenu}>
              <i className="fa-solid fa-ellipsis-vertical"></i>
            </IconButton>
            <Menu id="page-options"
              anchorEl={this.state.optionsMenu}
              open={this.state.openMenu}
              onClose={this.handleCloseOptionsMenu}
              keepMounted
            >
              <MenuItem key="view-option" onClick={() => { this.handleOpenDraftModal(); this.handleCloseOptionsMenu() }}>
                <Typography className="typography-generic small"><i className="fa-solid fa-eye mr-5"></i>{localizer.ViewDocument}</Typography>
              </MenuItem>
              {((this.state.shipment.dequeuedTime !== null) || this.props.currentUser.toLowerCase() !== this.state.shipment.ownerUser.toLowerCase()) ?
                <MenuItem key="edit-option" onClick={() => { this.setState({ message: localizer.CannotBeEditedShipment }) }}>
                  <Typography className="typography-generic small" >
                    <i className="fa-solid fa-pencil mr-5"></i>
                    {localizer.EditShipment}
                  </Typography>
                </MenuItem>
                :
                <MenuItem key="edit-option" onClick={() => { window.location.href = '/shipment?shipmentCode=' + this.state.shipment.shipmentCode }}>
                  <Typography className="typography-generic small" >
                    <i className="fa-solid fa-pencil mr-5"></i>
                    {localizer.EditShipment}
                  </Typography>
                </MenuItem>
              }
              {((this.state.shipment.dequeuedTime !== null) || this.props.currentUser.toLowerCase() !== this.state.shipment.ownerUser.toLowerCase()) ?
                <MenuItem key="cancel-option" onClick={() => { this.setState({ message: localizer.CannotBeDeletedShipment }) }}>
                  <Typography className="typography-generic small" >
                    <i className="fa-solid fa-circle-xmark mr-5"></i>
                    {localizer.CancelShipment}
                  </Typography>
                </MenuItem>
                :
                <MenuItem key="cancel-option" onClick={() => { this.handleOpenShipmentModal(); this.handleCloseOptionsMenu() }}>
                  <Typography className="typography-generic small" >
                    <i className="fa-solid fa-circle-xmark mr-5"></i>
                    {localizer.CancelShipment}
                  </Typography>
                </MenuItem>
              }
              
            </Menu>
          </TableCellStyled>


        </TableRowStyled>

        {/* Collapse row */}
        <TableRow>
          <TableCellStyled style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
              <Grid container direction="row">
                <Grid item md={12} style={{ maxHeight: 220, borderBottom: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxShipmentInfo}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12}>
                    <Grid item md={3}><Typography className="typography-generic bigweight">{localizer.InboxShipmentType}:</Typography></Grid>
                    <Grid item md={9}><Typography className="typography-generic">{this.getProductDescription()}</Typography></Grid>
                  </Grid>
                  <Grid container item md={12}>
                    <Grid item md={3}><Typography className="typography-generic bigweight">{localizer.InboxDestination}:</Typography></Grid>
                    <Grid item md={9}>
                      <Typography className="typography-generic white-space-pre" style={{ overflowX: "auto" }}>{this.mountDestinationAddress()}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container direction="row" style={{ padding: "5px", margintop: "5px" }}>
                <Grid item md={11} style={{ maxHeight: 50 }}></Grid>
                <Grid item md={1} style={{ maxHeight: 50 }}>
                  <Button className="button-generic card" variant="outlined" size="small" onClick={this.handleOpenModal}>{localizer.InboxViewAll}</Button>
                </Grid>

              </Grid>
            </Collapse>
          </TableCellStyled>
        </TableRow>

        {/* if openModal= true */}
        {this.state.openModal &&
          <ShipmentSavedSummary shipmentCode={this.state.shipment.shipmentCode} openModal={this.state.openModal} handleCloseModal={this.handleCloseModal}></ShipmentSavedSummary>
        }

        <Dialog
          open={this.state.openShipmentModal}
          onClose={this.handleCloseShipmentModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          {/* If the shipment has already been consolidated, the option you have is:
              • Mark it as canceled (an internal email will arrive to try to get out of the process)
            If the shipment has not yet been consolidated, the options you have are:
              • Mark the shipment as canceled (will not consolidate but is still listed in canceled status)
              • Delete the shipment keeping the draft document (in case you want to use it in a future shipment)
              • Delete the submission and also delete the draft document
            If the shipment has been cancelled, the options you have are:            
              • Delete the shipment keeping the draft document (in case you want to use it in a future shipment)
              • Delete the submission and also delete the draft document
            */}
          
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseShipmentModal}></i>
            {/* title according to state */}
            {this.state.shipment.emissionTime === null &&
              <Typography className="typography-generic dialog-title">{localizer.DeleteShipment}</Typography>
            }
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={2}>
                {/* message according to state */}
                {/* saved */}
                {(this.state.shipment.emissionTime === null) &&
                  <Grid>
                    <Typography className="typography-generic">{localizer.TheShipment}{this.state.shipment.shipmentCode} {localizer.DeleteShipmentConfirmation}</Typography>
                    <Typography className="typography-generic">{localizer.AreYouSure}</Typography>
                  </Grid>
                }
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseShipmentModal}>{localizer.Cancel}</Button>
                <Button name="DELETE" className="button-generic dialog-delete" variant="contained" onClick={this.deleteShipment}>{localizer.Delete}</Button>
              </Grid>
            </Grid>
          </DialogContent>
          
        </Dialog>

        <Dialog
          open={this.state.openDraftModal}
          onClose={this.handleCloseDraftModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <Typography className="typography-generic dialog-title">{localizer.PDFPreview}</Typography>
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseDraftModal}></i>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <MultiShipmentImageViewer
              shipmentId={this.state.shipment.shipmentId}
              documentpages={this.state.documentpages}
              pagenumber={this.state.pagenumber}
              viewerWidth={500}
              viewerHeight={600}
            />
          </DialogContent>
          
        </Dialog>

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.uploadDraftError} severity="error" handleonClose={this.handleonClose} />
        
        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.pageBase64Error} severity="error" handleonClose={this.handleonClose} />

        {/* General error. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipment-saved/sections/ShipmentSavedRow.js